import React from 'react';
import { Chip } from '@mui/material';


export default function TagChip(props) {
  return (
    <Chip
      {...props}
      sx={{ 
        m: 0.5, 
        backgroundColor: theme => theme.palette.primary.light, 
        color: theme => theme.palette.sys.onPrimary,
        '& .MuiChip-deleteIcon': {
          color: 'inherit',
          '&:hover': {
            color: 'inherit',
            opacity: 0.7,
          },
        },
      }}
      size='small'
    />
  );
}